import * as defaultImport from "@splunk/react-icons/Pencil";
export * from "@splunk/react-icons/Pencil";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
